import React from 'react'
import clsx from 'classnames'
import type { Salon, SalonOptions, SalonPage } from 'api/api.types'
import { formatPhone } from 'utils/formatPhone'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import styles from './SalonInfo.module.scss'

const OPTIONS: Array<{ icon: string, title: string, option: keyof SalonOptions }> = [
  { icon: 'kids', title: 'Детский уголок', option: 'hasKids' },
  { icon: 'coffee', title: 'Чай / Кофе', option: 'hasCoffee' },
  { icon: 'ramp', title: 'Пандус для инвалидов', option: 'hasRamp' },
  { icon: 'parking', title: 'Городская парковка', option: 'hasParking' },
  { icon: 'wifi', title: 'Бесплатный WiFi', option: 'hasWifi' },
  { icon: 'brows', title: 'Услуги бровиста', option: 'hasBrows' },
]

type SalonInfoProps = {
  salon: Pick<Salon, 'businessHours'>,
  meta: SalonPage,
}

/** Address, hours, phones and amenities on the salon page */
export const SalonInfo: React.FC<SalonInfoProps> = (props) => {
  const { salon, meta } = props
  const { options, salonName, salonAddress, salonPhones } = meta.templateVars.pageVars
  const hasOptions = Object.values(options).some((o) => !!o)

  return (
    <div className={styles.container} itemScope itemType={'http://schema.org/Organization'}>
      <div className={styles.addressContainer}>
        <i className={styles.icon} />
        <div className={styles.info}>
          <div className={styles.name} itemProp="name">
            {salonName}
          </div>
          <div className={styles.address} itemProp="address">
            {salonAddress}
          </div>
        </div>
      </div>
      <div className={clsx([styles.props, styles.businessHours])}>
        <div className={styles.title}>
          Время работы
        </div>
        <div className={styles.value}>
          {salon.businessHours}
        </div>
      </div>
      <div className={clsx([styles.props, styles.contacts])}>
        <div className={styles.title}>
          Контакты
        </div>
        {salonPhones.map(({ phone }) => (
          <div key={phone} className={styles.value} itemProp="telephone">
            <a href={`tel:+${phone}`}>
              {formatPhone(phone)}
            </a>
          </div>
        ))}
      </div>
      <div className={clsx([styles.props, styles.callButton])}>
        <a href={`tel:+${salonPhones?.[0]?.phone}`}>
          <AppButton shadowColor={'yellow'}>
            Позвонить
          </AppButton>
        </a>
      </div>
      {hasOptions && <div className={clsx([styles.props, styles.options])}>
        <ul className={styles.value}>
          {OPTIONS.filter(({ option }) => options[option]).map(({ icon, title }) => (
            <li key={icon} data-icon={icon} title={title} className={clsx([styles.option, styles.active])}>
              {title}
            </li>
          ))}
        </ul>
      </div>}
    </div>
  )
}
